module.exports = __webpack_public_path__ + "img/cpjs1.56c4b2be.png";